export default __webpack_public_path__ + "44911288c8a7c703ab9ccef289fa8ffc.jpg";